import React from 'react';
import { ArrowRight, FileText, Zap, Users, ShieldCheck, Lock, CreditCard } from 'lucide-react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/byuur79LNRBprjF7bZWbUq/Untitled_design_(9).png';
type Item = {
  icon: React.ReactNode;
  label: string;
};
const pills: Item[] = [{
  icon: <FileText className="h-4 w-4 text-[#2DD4C8]" aria-hidden="true" data-id="element-5" data-mp="4m8msdv40tlg" />,
  label: 'PDF digital'
}, {
  icon: <Zap className="h-4 w-4 text-[#2DD4C8]" aria-hidden="true" data-id="element-6" data-mp="12a0kra1zryu3" />,
  label: 'Acceso inmediato'
}, {
  icon: <Users className="h-4 w-4 text-[#2DD4C8]" aria-hidden="true" data-id="element-7" data-mp="x9usbrnwe8ay" />,
  label: 'Todos los niveles'
}];
const trust: Item[] = [{
  icon: <ShieldCheck className="h-4 w-4 text-[#2DD4C8]" aria-hidden="true" data-id="element-8" data-mp="sa027qby5mqy" />,
  label: 'Garantía 7 días'
}, {
  icon: <Lock className="h-4 w-4 text-[#2DD4C8]" aria-hidden="true" data-id="element-9" data-mp="nbonb16som1v" />,
  label: 'Pago 100% seguro'
}, {
  icon: <CreditCard className="h-4 w-4 text-[#2DD4C8]" aria-hidden="true" data-id="element-10" data-mp="3d2torapbqmf2" />,
  label: 'Mercado Pago / Tarjetas'
}];
const benefits = ['6 Tomos', '60+ Clases', '6 Bonos', 'Cuerpo Seguro Pro incluido'];
export function Hero() {
  return <section className="relative w-full min-h-screen overflow-hidden bg-[#061A21] font-heading" aria-labelledby="hero-title" data-id="element-11" data-mp="3o7lqxnqt30nd">
      {/* Ambient light */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(58% 45% at 50% 42%, rgba(45,212,200,0.16) 0%, rgba(45,212,200,0.05) 40%, rgba(6,26,33,0) 74%)'
    }} data-id="element-12" data-mp="39a38120t7hnu" />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(80% 50% at 50% 0%, rgba(255,255,255,0.05) 0%, rgba(6,26,33,0) 60%)'
    }} data-id="element-13" data-mp="359j8xswoe3z2" />

      <div className="relative mx-auto flex min-h-screen w-full max-w-[1200px] flex-col items-center justify-center px-6 py-20 text-center sm:px-10 lg:py-24" data-id="element-14" data-mp="2hj5ig6tqod6l">
        {/* Badge */}
        <span className="inline-flex items-center rounded-full border border-[#2DD4C8]/40 bg-transparent px-5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#7FF0E6]" data-id="element-15" data-mp="2lmlaepuv5pcy">
          Colección completa™
        </span>

        {/* Title */}
        <h1 id="hero-title" className="mt-8 text-[3rem] font-bold uppercase leading-[0.92] tracking-[-0.035em] text-white sm:text-[4.5rem] lg:text-[6.5rem]" data-id="element-16" data-mp="id9r45wihxq4">
          Stretching
          <br data-id="element-17" data-mp="1azkqxecanulv" />
          <span className="bg-clip-text text-transparent" style={{
          backgroundImage: 'linear-gradient(100deg, #7FF0E6 0%, #2DD4C8 45%, #12A79E 100%)'
        }} data-id="element-18" data-mp="1b04aezhler20">
            Resuelto
          </span>
          <span className="align-super text-[0.28em] font-semibold text-[#2DD4C8]" data-id="element-19" data-mp="x14pa1tagual">™</span>
        </h1>

        {/* Subtitle with side rules */}
        <div className="mt-7 flex w-full max-w-2xl items-center gap-4 sm:gap-6" data-id="element-20" data-mp="3lu07neppzt62">
          <span aria-hidden="true" className="h-px flex-1 bg-gradient-to-r from-transparent to-white/25" data-id="element-21" data-mp="3hr3sjxze2f6v" />
          <p className="whitespace-nowrap text-[11px] font-medium uppercase tracking-[0.18em] text-white/70 sm:text-sm sm:tracking-[0.22em]" data-id="element-22" data-mp="1xb5omas9olej">
            Todo tu año de clases, <span className="text-[#2DD4C8]" data-id="element-23" data-mp="268y71ntac965">organizado.</span>
          </p>
          <span aria-hidden="true" className="h-px flex-1 bg-gradient-to-l from-transparent to-white/25" data-id="element-24" data-mp="2b0fynl9f4xeg" />
        </div>

        {/* Main image */}
        <div className="relative mt-10 w-full" data-id="element-25" data-mp="2kyvnfhkz3uks">
          <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[80%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl" style={{
          background: 'radial-gradient(circle, rgba(45,212,200,0.18) 0%, rgba(45,212,200,0.05) 45%, rgba(6,26,33,0) 70%)'
        }} data-id="element-26" data-mp="2kxkktl39ksv9" />
          <img src={MOCKUP_URL} alt="Colección Stretching Resuelto: 6 tomos impresos, notebook con el sistema completo, manual Cuerpo Seguro Pro, celular con los 6 bonos, banda elástica, mat, foam roller y planilla de planificación de clase." className="relative mx-auto w-full max-w-[940px]" loading="eager" data-id="element-27" data-mp="zkr8kl0vbi9f" />
        </div>

        {/* Benefits */}
        <p className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-base font-medium text-white/90 sm:text-lg" data-id="element-28" data-mp="9bigfeqehkj2">
          {benefits.map((benefit, i) => <React.Fragment key={benefit} data-id="element-29" data-mp="3crpjbj0zrdqs" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" className="text-[#2DD4C8]/60" data-id="element-30" data-mp="3cpctkjozrz36">
                  •
                </span>}
              <span data-id="element-31" data-mp="3motvqr51buue">{benefit}</span>
            </React.Fragment>)}
        </p>

        {/* Description */}
        <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-white/55 sm:text-base" data-id="element-32" data-mp="2yyr7km48r912">
          Clases, técnica, progresión, adaptaciones y comunicación profesional para enseñar con un
          sistema real. Sin improvisar.
        </p>

        {/* Pills */}
        <ul className="mt-8 flex flex-wrap justify-center gap-2.5" aria-label="Características del producto" data-id="element-33" data-mp="1e93xzr8qkmom">
          {pills.map(pill => <li key={pill.label} className="inline-flex items-center gap-2 rounded-full border border-[#2DD4C8]/30 bg-[#04161C] px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/80" data-id="element-34" data-mp="zlspjy7upisq">
              {pill.icon}
              {pill.label}
            </li>)}
        </ul>

        {/* CTA */}
        <a href="#comprar" className="group mt-10 flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-[#2DD4C8] px-8 py-5 text-center text-[15px] font-bold uppercase tracking-[0.06em] text-black shadow-[0_18px_50px_-14px_rgba(45,212,200,0.65)] transition-all hover:bg-[#3FE3D6] hover:shadow-[0_22px_60px_-12px_rgba(45,212,200,0.8)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7FF0E6] focus-visible:ring-offset-2 focus-visible:ring-offset-[#061A21] sm:text-base" data-id="element-35" data-mp="1j903jux30m6a">
          Quiero mi Stretching Resuelto
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-36" data-mp="29ktptw4w6fdi" />
        </a>

        {/* Trust bar */}
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-[13px] text-white/50" aria-label="Garantías" data-id="element-37" data-mp="1zrmnyl9d1hi6">
          {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2" data-id="element-38" data-mp="1qqy61fguix00">
              {item.icon}
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}